module.exports = __webpack_public_path__ + "img/1 (9).e5182eea.jpg";